export const getOccupancies = () => {
  const params = new URLSearchParams(location.search)
  const adults = []
  const childrens = []
  const childrenV2 = []
  for (const [key, value] of params) {
    if (key === 'adults[]') {
      adults.push(parseInt(value))
    }
    if (key === 'children[]') {
      childrens.push(parseInt(value))
    }
    if (key === 'aoc[]') {
      childrenV2.push(
        (!!value && value !== 'NaN' ? value : undefined)
          ?.split(',')
          .map(age => parseInt(age))
          .map(age => ({ age }))
      )
    }
  }
  return adults.map((adult, index) => ({
    adults: adult,
    children: childrens[index],
    childrenV2: childrenV2[index]
  }))
}
